/**
 * Shared console diagnostics for Word.js / RichApi failures (GeneralException, etc.).
 */

export function officeErrorToLogObject(err: unknown): Record<string, unknown> {
  if (err === null || err === undefined) {
    return { value: err };
  }
  if (typeof err !== "object") {
    return { value: err };
  }
  const e = err as Record<string, unknown> & { message?: string; name?: string; stack?: string };
  const out: Record<string, unknown> = {};
  if (typeof e.name === "string") {
    out.name = e.name;
  }
  if (typeof e.message === "string") {
    out.message = e.message;
  }
  if (typeof e.stack === "string") {
    out.stack = e.stack;
  }
  const copyKeys = [
    "code",
    "debugInfo",
    "traceMessages",
    "innerError",
    "httpStatusCode",
    "body",
    "statusCode"
  ] as const;
  for (const k of copyKeys) {
    if (k in e && e[k] !== undefined) {
      out[k] = e[k];
    }
  }
  return out;
}

/** Wrap `context.sync()` so failures log which step failed before rethrowing. */
export async function wordSyncWithLog(
  context: Word.RequestContext,
  logPrefix: string,
  step: string,
  meta?: Record<string, unknown>
): Promise<void> {
  try {
    await context.sync();
  } catch (e) {
    console.warn(logPrefix, "context.sync() failed", { step, ...meta, error: officeErrorToLogObject(e) });
    throw e;
  }
}
